export { default as StatusGantt, StatusGanttProps, StatusGanttVariantType } from "./StatusGantt.component";
